<template>
    <div>
        <v-timeline side="end" align="start">
            <template v-for="group in groups" :key="group.key">
                <v-timeline-item dot-color="pink" size="small">
                    <div class="history-group-title">{{ group.key }}</div>
                </v-timeline-item>
                <v-timeline-item size="small" v-for="item in group.items" :key="item.user.id">
                    <template v-slot:icon>
                        <v-tooltip open-delay="1000">
                            <template v-slot:activator="{ props }">
                                <avatar-view :size="32" :user="item.user" v-bind="props"></avatar-view>
                            </template>
                            <v-lazy>
                                <user-detail :user="item.user" />
                            </v-lazy>
                        </v-tooltip>
                    </template>
                    <div class="message">
                        <b>{{ content(item.user) }}</b>
                        <span class="content-message">{{message(item)}}</span>
                    </div>
                    <div v-for="(file, id) in item.files" :key="id" class="history-folder-tree">
                        <history-folder :file="file" :owner="owner" :type="item.type" />
                    </div>
                </v-timeline-item>
            </template>
        </v-timeline>
    </div>
    <div v-if="state != 0" class="loading-pane">
        <div>{{ $tr('Загрузка...') }}</div>
    </div>
</template>

<script>
import Utils from '@topomatic/tap/src/utils';
import AvatarView from '@topomatic/tap/src/components/AvatarView.vue';
import UserDetail from '@topomatic/tap/src/components/UserDetail.vue';
import AppConsts from '../consts';
import HistoryFolder from './HistoryFolder.vue';

const STATE_LOADED = 0;
const STATE_INVALID = 1;
const STATE_LOADING = 2;

function createFolderChilds(childs, files, map) {
    if (childs == undefined) {
        return undefined;
    }
    const folders = [];
    for (let i = 0; i < childs.length; i++) {
        const child = childs[i];
        const history = [];
        for (let j = 0; j < child.length; j++) {
            history.push(child[j].data);
        }
        if (child.length > 0) {
            const item = child[0];
            const { data } = item;
            const obj = {
                history,
                date: item.date,
                id: item.file,
            };
            let name;
            let type = AppConsts.FOLDER_TYPE;
            const file = files[item.file];
            if (data != undefined) {
                name = data.name;
                type = data.type;
            }
            if ((name == undefined) || (type == undefined)) {
                if (file != undefined) {
                    name = file.name;
                    type = file.type;
                } else {
                    let req = map[item.file];
                    if (req == undefined) {
                        req = [];
                        map[item.file] = req;
                    }
                    req.push(obj);
                }
            } else if (file == undefined) {
                files[item.file] = {
                    name,
                    type,
                };
            }
            obj.name = name;
            obj.type = type;
            if (child.childs != undefined) {
                obj.files = createFolderChilds(child.childs, files, map);
            }
            folders.push(obj);
        }
    }
    return folders;
}

function createFolderTree(groups, files, map) {
    const folder = [];
    const keys = Object.keys(groups);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const item = groups[key];
        if (key == 'null') {
            const items = createFolderChilds(item, files, map);
            if (items != undefined) {
                for (let j = 0; j < items.length; j++) {
                    folder.push(items[j]);
                }
            }
        } else {
            let name;
            let type = AppConsts.FOLDER_TYPE;
            const obj = {
                id: key,
            };
            const file = files[key];
            if (file != undefined) {
                name = file.name;
                type = file.type;
            } else {
                let req = map[key];
                if (req == undefined) {
                    req = [];
                    map[key] = req;
                }
                req.push(obj);
            }
            obj.name = name;
            obj.type = type;
            if (item != undefined) {
                obj.files = createFolderChilds(item, files, map);
            }
            folder.push(obj);
        }
    }
    return folder;
}

function filterGroup(api, items, files, map) {
    let i = 0;
    const created = {};
    while (i < items.length) {
        const item = items[i];
        i++;
        if (item.type == 1) {
            created[item.file] = item.user;
        }
    }
    i = items.length - 1;
    while (i >= 0) {
        const item = items[i];
        i--;
        if (item.type == 2) {
            const c = created[item.file];
            if (c == item.user) {
                items[i + 1] = null;
                created[item.file] = null;
            }
        }
    }
    i = 0;
    const users = [];
    while (i < items.length) {
        const item = items[i];
        items[i] = null;
        i++;
        if (item == null) {
            continue;
        }
        const group = {};
        group[item.file] = [item];
        for (let j = i; j < items.length; j++) {
            const sitem = items[j];
            if (sitem == null) {
                continue;
            }
            if ((sitem.user == item.user) && (item.type == sitem.type)) {
                items[j] = null;
                let existing = group[sitem.file];
                if (existing == undefined) {
                    existing = [];
                    group[sitem.file] = existing;
                }
                existing.push(sitem);
            } else {
                break;
            }
        }
        const pg = {};
        let length = 0;
        for (const f in group) {
            length += 1;
            const gitem = group[f];
            const { parent } = gitem[0];
            const sub = group[parent];
            if (sub != undefined) {
                if (sub.childs == undefined) {
                    sub.childs = [];
                }
                sub.childs.push(gitem);
            } else {
                let existing = pg[parent];
                if (existing == undefined) {
                    existing = [];
                    pg[parent] = existing;
                }
                existing.push(gitem);
            }
        }
        users.push({
            user: api.get_user(item.user),
            type: item.type,
            length,
            files: createFolderTree(pg, files, map),
        });
    }
    return users;
}

export default {
    components: {
        HistoryFolder,
        UserDetail,
        AvatarView,
    },
    name: 'FileHistory',
    props: {
        data: Object,
    },
    data() {
        return {
            state: STATE_INVALID,
            cgroups: [],
        };
    },
    computed: {
        groups() {
            if (this.state == STATE_INVALID) {
                this.fetchHistory(this.data.file, this.data.path.length == 1 ? 0 : 5);
            }
            return this.cgroups;
        },
        owner() {
            const { file } = this.data;
            let owner = file.user || file.company;
            if ((owner == undefined) && (this.data.path != undefined)) {
                for (const item of this.data.path) {
                    owner = item.user || item.company;
                    if (owner != undefined) {
                        break;
                    }
                }
            }
            return owner;
        },
    },
    methods: {
        message(item) {
            let msg;
            const { length } = item;
            switch (item.type) {
            case 1: // HISTORY_CREATE_FILE
                msg = this.$plural('создал {0} объект', length);
                break;
            case 2: // HISTORY_UPDATE_REVISION
                msg = this.$plural('изменил {0} объект', length);
                break;
            case 3: // HISTORY_UPDATE_NAME
                msg = this.$plural('переименовал {0} объект', length);
                break;
            case 4: // HISTORY_UPDATE_DESCRIPTION
                msg = this.$plural('изменил описание {0} объекта', length);
                break;
            case 5: // HISTORY_TRASH_FILE
                msg = this.$plural('удалил в корзину {0} объект', length);
                break;
            case 7: // HISTORY_UPDATE_USER_PERMISSION
                msg = this.$plural('изменил права доступа пользователя к {0} объекту', length);
                break;
            case 8: // HISTORY_UPDATE_GROUP_PERMISSION
                msg = this.$plural('изменил права доступа группы к {0} объекту', length);
                break;
            case 9: // HISTORY_DELETE_USER_PERMISSION
                msg = this.$plural('отозвал права доступа пользователя к {0} объекту', length);
                break;
            case 10: // HISTORY_DELETE_GROUP_PERMISSION
                msg = this.$plural('отозвал права доступа группы к {0} объекту', length);
                break;
            case 11: // HISTORY_DELETE_FILE
                msg = this.$plural('безвозвратно удалил {0} объект', length);
                break;
            default:
                msg = '';
                console.log(item.type);
            }
            if (msg != undefined) {
                return msg.replace('{0}', length);
            }
            return '';
        },
        fetchHistory(file, depth) {
            this.state = STATE_LOADING;
            this.$api.getHistory(file.id, depth)
                .then((data) => {
                    if (this.data.file.id != file.id) {
                        return;
                    }
                    const history = [];
                    const d = data.history;
                    const files = {};
                    this.$api.getFiles(file.id, depth, false, true).then((fdata) => {
                        for (let i = 0; i < fdata.files.length; i += 1) {
                            const cfile = fdata.files[i];
                            files[cfile.id] = cfile;
                        }
                        files[file.id] = file;
                        for (let i = 0; i < this.data.path.length; i++) {
                            const path = this.data.path[i];
                            files[path.id] = path;
                        }
                        history.push({
                            parent: file.parent,
                            file: file.id,
                            date: file.created,
                            user: file.creator,
                            type: 1,
                            data: {
                                name: file.name,
                                type: file.type,
                            },
                        });
                        for (let i = 0; i < d.length; i++) {
                            const f = d[i];
                            f.history.sort((a, b) => ((new Date(a.date) < new Date(b.date)) ? 1 : -1));
                            for (let j = 0; j < f.history.length; j++) {
                                const h = f.history[j];
                                const { hdata } = h;
                                if (hdata != undefined) {
                                    const { id } = hdata;
                                    if ((h.type == 1) || (h.type == 11)) {
                                        history.push({
                                            parent: f.id,
                                            file: id,
                                            date: h.date,
                                            user: h.user,
                                            type: h.type,
                                            hdata,
                                        });
                                    }
                                }
                            }
                        }
                        for (let i = 0; i < d.length; i++) {
                            const f = d[i];
                            for (let j = 0; j < f.history.length; j++) {
                                const h = f.history[j];
                                if ((h.type != 1) && (h.type != 11)) {
                                    history.push({
                                        parent: f.parent,
                                        file: f.id,
                                        date: h.date,
                                        user: h.user,
                                        type: h.type,
                                        data: h.data,
                                    });
                                }
                            }
                        }
                        history.sort((a, b) => ((new Date(a.date) < new Date(b.date)) ? 1 : -1));
                        let items = [];
                        let lkey;
                        const groups = [];
                        const map = {};
                        for (let i = 0; i < history.length; i++) {
                            const item = history[i];
                            const key = Utils.dateTimeFromNow(item.date);
                            if (key != lkey) {
                                if (items.length > 0) {
                                    groups.push({
                                        key: lkey,
                                        items: filterGroup(this.$api, items, files, map),
                                    });
                                    items = [];
                                }
                                lkey = key;
                            }
                            items.push(item);
                        }
                        if (items.length > 0) {
                            groups.push({
                                key: lkey,
                                items: filterGroup(this.$api, items, files, map),
                            });
                        }
                        const root = this.data.path[0].id;
                        for (let i = 0; i < groups.length; i++) {
                            const group = groups[i];
                            for (let j = 0; j < group.items.length; j++) {
                                const item = group.items[j];
                                for (let k = 0; k < item.files.length; k++) {
                                    const pfile = item.files[k];
                                    if (pfile.id == root) {
                                        pfile.type = AppConsts.DRIVE_TYPE;
                                    }
                                }
                            }
                        }
                        const ids = Object.keys(map);
                        if (ids.length > 0) {
                            const preloads = [];
                            for (let i = 0; i < ids.length; i++) {
                                const id = ids[i];
                                const values = map[id];
                                preloads.push(new Promise((resolve) => {
                                    this.$api.getFile(id)
                                        .then((cdata) => {
                                            const pfile = cdata.file;
                                            const name = pfile.name;
                                            const type = pfile.type;
                                            for (let j = 0; j < values.length; j++) {
                                                const value = values[j];
                                                value.name = name;
                                                value.type = type;
                                            }
                                            resolve();
                                        })
                                        .catch(resolve);
                                }));
                            }
                            Promise.all(preloads)
                                .finally(() => {
                                    this.cgroups = groups;
                                    this.state = STATE_LOADED;
                                });
                        } else {
                            this.cgroups = groups;
                            this.state = STATE_LOADED;
                        }
                    });
                });
        },
        content(user) {
            if (user != undefined) {
                return Utils.userToString(user);
            }
            return '';
        },
    },
    watch: {
        data() {
            this.state = STATE_INVALID;
        },
    },
};
</script>

<style scoped>
.loading-pane {
    background-color: rgba(var(--v-theme-surface), 0.8) !important;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
}
.loading-pane div {
    padding-top: 150px;
}
.history-group-title {
    font-weight: bold;
    color: rgba(var(--v-theme-on-surface), 0.6) !important;
    border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.2) !important;
}
.message {
    padding-bottom: 8px;
}
.history-folder-tree {
  overflow-y: hidden;
  overflow-x: auto;
}

.content-message {
    padding-left: 4px;
}
</style>
